module.exports = __webpack_public_path__ + "img/logonext360.7d40fc69.svg";